import type {GetWhoamiResponse} from '@myparcel-frontend/iam-service';
import {defineStore} from 'pinia';
import {computed, ref} from 'vue';

export const useServiceAccountStore = defineStore('serviceAccount', () => {
  const account = ref<GetWhoamiResponse>();

  const isImpersonated = computed(() => !!account.value?.impersonator);

  return {
    account,
    isImpersonated,
  };
});
